import React, { Fragment } from 'react';
import { exportAllBusinessPlansResults } from '../../ExportResults';

const ExportResults = ({ game, children }) => {
	const businessPlans = game.businessPlans.filter(b => b.submittedAt)
	return (
		<Fragment>
			{
				businessPlans.length > 0
					? <div onClick={() => exportAllBusinessPlansResults(businessPlans)} className="export-results">
						{children}
					</div>
					: null
			}
			
		</Fragment>
	)
};

export default ExportResults;
